import { OUTPUT_TTL } from '../../../constants/Pac';

/**
 * Vibrator controller
 *
 * @param rootStore
 * @param vibratorId
 * @param turnOn
 */
export const vibratorSwitch = (rootStore, vibratorId, turnOn = true) => {
  const { batchStore, devicesStore } = rootStore;

  if (vibratorId) {
    const vibrator = devicesStore.getDeviceById(vibratorId);

    if (vibrator?.switchOnePNo) {

      if (batchStore.isOutputOn(vibrator.switchOnePNo) === turnOn) {
        return;
      }

      batchStore.setOutput(vibrator.switchOnePNo, turnOn ? OUTPUT_TTL : '0');
    }
  }
};
